/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const TransmittalRecordSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "transmittalId": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusCode": zod.string().optional(),
  "statusName": zod.string().optional(),
  "date": zod.coerce.date().optional(),
  "releasedDate": zod.coerce.date().optional(),
  "receivedDate": zod.coerce.date().optional(),
  "issuerId": zod.string().uuid().optional(),
  "issuerName": zod.string().optional(),
  "receiverId": zod.string().uuid().optional(),
  "receiverName": zod.string().optional(),
  "numberOfDocuments": zod.number().optional()
});

export type TransmittalRecordSummaryDto = zod.input<typeof TransmittalRecordSummaryDto>;
export type TransmittalRecordSummaryDtoOutput = zod.output<typeof TransmittalRecordSummaryDto>;
